import { render } from "./ImageEditorCmp.vue?vue&type=template&id=c6f61eba"
import script from "./ImageEditorCmp.vue?vue&type=script&lang=js"
export * from "./ImageEditorCmp.vue?vue&type=script&lang=js"

import "./ImageEditorCmp.vue?vue&type=style&index=0&id=c6f61eba&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__